import type { FC } from 'react';
import React, { memo } from 'react';

import { Box } from '@mui/material';
import { AspectRatio } from 'react-aspect-ratio';

import { useAuthorizedFile } from '@pages/organizer/Cloud/hooks/use-authorized-file';
import { MuiPreloader } from 'shared/ui-kit';

import type { MediaType } from '@shared/models/media.model';
import type { AttachmentsProps } from 'shared/ui-kit';

const imageSrc = (attachmentsItem: MediaType) => {
  return (
    attachmentsItem?.additional_info?.size_urls?.gallery ||
    attachmentsItem?.additional_info?.size_urls?.avatar_lg ||
    attachmentsItem?.additional_info?.size_urls?.avatar_profile ||
    attachmentsItem?.additional_info?.size_urls?.attachment_middle ||
    attachmentsItem?.url ||
    ''
  );
};

type imagePropsType = {
  attachmentsItem: MediaType;
} & Pick<AttachmentsProps, 'aspectRatio' | 'heightImage' | 'isProtectedUrl'>;
export const Image: FC<imagePropsType> = memo((props) => {
  const { attachmentsItem, heightImage, aspectRatio, isProtectedUrl } = props;

  const { blobUrl } = useAuthorizedFile({
    url: imageSrc(attachmentsItem),
    isProtectedUrl: isProtectedUrl,
  });

  return (
    <AspectRatio ratio={aspectRatio} style={{ ...(heightImage && { height: heightImage }) }}>
      {blobUrl ? (
        <img src={blobUrl} alt={`file-${imageSrc(attachmentsItem)}`} />
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MuiPreloader isShow size="medium" />
        </Box>
      )}
    </AspectRatio>
  );
});
